import moment from "moment";
import "moment/locale/es";

import numeral from "numeral";

moment.locale("es");

export const formatDateTime = (value, format = "DD/MM/YYYY HH:mm:ss") => (value ? moment(value).format(format) : "");
export const formatDate = (value, format = "DD/MM/YYYY") => (value ? moment(value).format(format) : "");

/**
 *
 * @param {string} value input date to format to iso-date
 * @param {string} format input format
 * @returns iso string date
 */
export const formatDate2Iso = (value, format) => (value ? momentObj(value, format)?.toISOString() : "");

export const momentObj = (value, format) => (value && format ? moment(value, format) : value ? moment(value) : null);

export const formatMoney = (value, format = "$ 0,0.00") => (value != null ? numeral(value).format(format) : "");

export const getStatusComprobante = (comprobante, extraClass = "") => {
    if (!comprobante) return <></>;
    if (comprobante.cancelado) {
        return (
            <span className={"badge bg-green me-1 " + extraClass}>
                <i className="fas fa-square-check fa-fw "></i>PAGADA
            </span>
        );
    } else if (comprobante.importe == comprobante.pendiente) {
        return (
            <span className={"badge bg-red me-1 " + extraClass}>
                <i className="fas fa-warning fa-fw "></i>PENDIENTE DE PAGO
            </span>
        );
    } else {
        return (
            <span className={"badge bg-warning me-1 " + extraClass}>
                <i className="fas fa-fill fa-fw "></i>PAGO PARCIAL
            </span>
        );
    }
};
